import { FontAwesomeIconNames } from "../Components/clientportal/data";


export const getIconForFileType = (fileName: string): string => {
    const extension = fileName.split('.').pop();
    if (extension === 'docx') {
        return FontAwesomeIconNames.lightWord
    } else if (extension === 'pdf') {
        return FontAwesomeIconNames.lightPdf
    } else if (extension === 'jpeg' || extension === 'png' || extension === 'jpg') {
        return FontAwesomeIconNames.lightImage
    } else if (extension === 'mp4' || extension === 'mkv' || extension === 'avi' || extension === 'wmv') {
        return FontAwesomeIconNames.lightFileVideo
    } else if (extension === 'xls' || extension === 'xlsx' || extension === 'xlsm') {
        return FontAwesomeIconNames.lightFileExcel
    } else if (extension === 'ppt' || extension === 'pptx') {
        return FontAwesomeIconNames.lightFilePowerpoint
    } else {
        return FontAwesomeIconNames.lightFile
    }
}

export default getIconForFileType;